"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SearchDrawer;
exports.styles = void 0;

var _react = _interopRequireDefault(require("react"));

var _Drawer = _interopRequireDefault(require("../drawer/Drawer"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useNavigationEvent = _interopRequireDefault(require("../hooks/useNavigationEvent"));

var styles = function styles(theme) {
  return {
    /**
     * Styles applied to the paper component in the [Drawer](/apiReference/drawer/Drawer).
     */
    paper: {
      display: 'flex'
    },

    /**
     * Styles applied to the root element in the [DrawerCloseButton](/apiReference/drawer/DrawerCloseButton).
     */
    closeButton: {
      color: theme.palette.primary.contrastText
    }
  };
};

exports.styles = styles;
var useStyles = (0, _styles.makeStyles)(styles, {
  name: 'RSFSearch'
});

function SearchDrawer(_ref) {
  _ref = Object.assign({}, {
  DrawerComponent: _Drawer["default"]
}, _ref);
  var DrawerComponent = _ref.DrawerComponent,
      classes = _ref.classes,
      open = _ref.open,
      onClose = _ref.onClose,
      children = _ref.children;
  classes = useStyles({
    classes: classes
  });

  var handleNavigation = function handleNavigation() {
    if (onClose) {
      onClose();
    }
  };

  (0, _useNavigationEvent["default"])(handleNavigation);
  return /*#__PURE__*/_react["default"].createElement(DrawerComponent, {
    classes: classes,
    open: open,
    anchor: "bottom",
    onClose: onClose,
    fullscreen: true
  }, children);
}

SearchDrawer.propTypes = {
  /**
   * Override or extend the styles applied to the component. See [CSS API](#css) below for more details.
   */
  classes: _propTypes["default"].object,

  /**
   * Children to be rendered inside the drawer.
   */
  children: _propTypes["default"].node,

  /**
   * If `true`, the search drawer should be open.
   */
  open: _propTypes["default"].bool,

  /**
   * A function that is called when the user closes the drawer.
   */
  onClose: _propTypes["default"].func.isRequired,

  /**
   * A component type to use for the drawer.
   */
  DrawerComponent: _propTypes["default"].elementType
};
